(ns rlws.iot-cloud.frontend.openapi
  (:require [potpuri.core :as potpuri]
            ["@rjsf/core" :refer [default] :rename {default Form}]
            [rlws.iot-cloud.frontend.site :as site]))

(defn create-enum
  "Create an enum type on the fly from a collection and a base schema"
  ([base items]
   (create-enum base items {}))
  ([base items {:keys [default? value-fn name-fn]
                :or {default? true
                     value-fn site/to-plain-id
                     name-fn :name}}]
   (reduce (fn [schema item]
             (-> schema
                 (update "enum" conj (value-fn item))
                 (update "enumNames" conj (name-fn item))))
           (merge base
                  {"enum" []
                   "enumNames" []}
                  (when default?
                    {"default" (value-fn (first items))}))
           items)))

(defn form
  "Builds an rjsf form representation from openapi spec for a given schema, looks
  for ui:schema descriptions under [:components :ui-schema] in the openapi spec,
  takes a map of remap-properties to overwrite the implementation of a specific
  property, values can either be a constant or a function, a nil will remove the
  property entirely including from required properties"
  [{:keys [openapi schema-name form-data remap-properties on-submit class]} & children]
  (let [unparseable-keys #{"keyword-mappings"}

        openapi'
        (->> openapi
             (clojure.walk/stringify-keys)
             (clojure.walk/postwalk (fn [a]
                                      (when-not (and (map-entry? a)
                                                     (unparseable-keys (key a)))
                                        a))))

        target-schema (get-in openapi' ["components" "schemas" schema-name])

        constants (clojure.walk/postwalk
                   (fn [a]
                     (cond
                       (map-entry? a)
                       (let [[k v] a]
                         (cond
                           (= "properties" k)
                           [k (potpuri/filter-vals #(contains? % "const") v)]

                           (= "allOf" k)
                           (->> v
                                (filter #(contains? % "properties"))
                                (map #(get % "properties"))
                                (apply merge))

                           :else
                           a))

                       (and (map? a)
                            (contains? a "$id"))
                       (dissoc a "$id")

                       :else
                       a))
                   target-schema)

        processed-schema (if remap-properties
                           (clojure.walk/postwalk
                            (fn [a]
                              (cond
                                (and (map-entry? a)
                                     (= "required" (key a)))
                                [(key a) (remove
                                          (fn [req-key]
                                            (and (contains? remap-properties req-key)
                                                 (nil? (remap-properties req-key))))
                                          (val a))]

                                (and (map-entry? a) (contains? remap-properties (key a)))
                                (let [remap-value (remap-properties (key a))]
                                  (if (fn? remap-value)
                                    [(key a) (remap-value (val a))]
                                    [(key a) remap-value]))

                                :else a))
                            target-schema)
                           target-schema)

        form-schema (clojure.walk/postwalk
                     (fn [a]
                       (cond
                         (and (map-entry? a)
                              (= "properties" (key a)))
                         [(key a) (potpuri/remove-keys (set (keys constants)) (val a))]

                         (and (map-entry? a)
                              (= "required" (key a)))
                         [(key a) (remove (set (keys constants)) (val a))]

                         :else a))
                     (merge (select-keys openapi' ["components"])
                            processed-schema))

        form-ui-schema (get-in openapi' ["components" "ui-schemas" schema-name])]

    (into [:> Form
           (cond-> {:schema form-schema
                    :form-data form-data
                    :live-validate false
                    :auto-complete "off"
                    :class-name class
                    :on-submit
                    (fn [form-state]
                      (let [keyword-constants (clojure.walk/keywordize-keys constants)
                            form-data (merge (:formData (js->clj form-state
                                                                 :keywordize-keys
                                                                 true))
                                             (potpuri/map-vals :const
                                                               keyword-constants))]
                        (on-submit form-data)))}
             form-ui-schema (assoc :ui-schema form-ui-schema))]
          children)))
